const route = () => '/notifications';

export default route;


